<template>
  <div class="screener-graph">
    <span :style="{ left: ((c - l) / (h - l)) * 100 + '%' }"></span>
  </div>
</template>

<script>
export default {
  props: {
    h: Number,
    l: Number,
    c: Number,
  },
}
</script>

<style lang="scss">
.screener-graph {
  position: relative;
  width: 120px;
  // background: #ededf3;
  background: #c2c2d657;
  left: 0;
  height: 12px;
  top: 1px;

  span {
    position: absolute;
    border: 1px solid #00a6cb;
    width: 1px;
    height: 100%;
    margin: 0;
  }
}
</style>
